import { APRCards } from "components/APRCards";
import type { APRCardsProps } from "components/APRCards";
import type { ReactStoryblokComponent } from "types/storyblok";

const APRCardsAdapter = ({ blok: { cards }, sbEditable }: ReactStoryblokComponent<APRCardsProps>) => (
  <APRCards cards={cards} sbEditable={sbEditable} />
);

export default APRCardsAdapter;
